<div class="loader-background"
     [ngClass]="{dark: !!dark, 'd-none': !!!loading}">

    <div class="content">
        <div class="center">

            <div class="loader-wrapper {{size}}"
                 [ngClass]="{dark: !dark, 'no-scale': !scale, 'no-alternate': !alternate}">

                <div class="loader-ring">
                </div>
            </div>
        </div>
    </div>
</div>
